import { isLoggedIn } from '@/utils/user';
import { AccountCircle, Login, Logout } from '@mui/icons-material';
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Typography, Stack, Collapse } from '@mui/material';
import { useContext, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs } from './Breadcrumbs';
import { login, logout } from '@/utils/auth';
import { AppContext } from '@/contexts/app.context';
import { getLocalStorageCredentialList } from '@/screens/login/Login';

export const WTFAppBar = (props: { setDrawerOpen: (open: boolean) => void; drawerOpen: boolean }) => {
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const user = context.state?.userProfile;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showUserLoginAsMenu, setShowUserLoginAsMenu] = useState(false);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky">
      <Toolbar>
        <IconButton onClick={() => props.setDrawerOpen(!props.drawerOpen)} size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
          <MenuIcon />
        </IconButton>
        <Breadcrumbs />
        {
          <div>
            <Stack direction={'row'} alignItems={'center'}>
              <Typography sx={{ textTransform: 'capitalize' }}>{user?.username}</Typography>
              <IconButton size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleMenu} color="inherit">
                <AccountCircle />
              </IconButton>
            </Stack>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              {isLoggedIn() && (
                <MenuItem
                  onClick={() => {
                    navigate('my-account');
                    handleClose();
                  }}
                >
                  <AccountCircle />
                  <Typography sx={{ mx: 1 }}>My account</Typography>
                </MenuItem>
              )}
              {isLoggedIn() && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                  }}
                  onMouseEnter={() => {
                    setShowUserLoginAsMenu(true);
                  }}
                  onMouseLeave={() => {
                    setShowUserLoginAsMenu(false);
                  }}
                >
                  <Logout /> <Typography sx={{ mx: 1 }}>Login As...</Typography>
                  <Collapse in={showUserLoginAsMenu} timeout="auto" unmountOnExit>
                    {getLocalStorageCredentialList().map((c) => (
                      <MenuItem
                        onClick={async () => {
                          logout();

                          const r = await login({ email: c.email ?? '', password: c.password ?? '' });
                          const profile = await context.refreshUserProfile();
                          handleClose();
                        }}
                      >
                        {c.email}
                      </MenuItem>
                    ))}
                  </Collapse>
                </MenuItem>
              )}
              {isLoggedIn() && (
                <MenuItem
                  onClick={() => {
                    logout();
                    navigate('/login');
                    handleClose();
                  }}
                >
                  <Logout /> <Typography sx={{ mx: 1 }}>Logout</Typography>
                </MenuItem>
              )}

              {!isLoggedIn() && (
                <MenuItem
                  onClick={() => {
                    logout();
                    navigate('/login');
                    handleClose();
                  }}
                >
                  <Login /> <Typography sx={{ mx: 1 }}>Login</Typography>
                </MenuItem>
              )}
            </Menu>
          </div>
        }
      </Toolbar>
    </AppBar>
  );
};
